import { ref } from 'vue';

/**
 * Kategori durum verilerini oluşturur
 * @returns {Object} - Kategori state verileri
 */
export const createCategoryState = () => {
  // Kategoriler
  const categoryOptions = ref([]);
  const isLoadingCategories = ref(false);

  return {
    categoryOptions,
    isLoadingCategories
  };
};